import Animated, {
  SharedValue,
  useAnimatedStyle,
  useDerivedValue,
  withTiming,
} from "react-native-reanimated";
import { Box, useTheme } from "arkh";
import { ResizeOptions, ResizePosition } from "./types";
import React from "react";
import { WidgetPos } from "../../types";
import { getResizePositions } from "./getResizePositions";
import { getWidgetSizeWorklet } from "../getWidgetSize";
export function ResizeIndicators(props: {
  widgets: SharedValue<WidgetPos[]>;
  id: string;
  numberOfRows: number;
}) {
  const resizeOptions = useDerivedValue((): Record<
    ResizePosition,
    ResizeOptions
  > => {
    const f = props.widgets.value.find((w) => w.id === props.id);
    if (!f) {
      return {
        top: { collapse: false, expand: 1 },
        bottom: { collapse: false, expand: 1 },
        left: { collapse: false, expand: 1 },
        right: { collapse: false, expand: 1 },
      };
    }
    const possibleSizes = getWidgetSizeWorklet(f);
    return getResizePositions(
      f,
      Object.values(props.widgets.value),
      possibleSizes,
      props.numberOfRows
    );
  }, [props.widgets.value, props.id]);
  return (
    <>
      <ResizeIndicator options={resizeOptions} position="top" />
      <ResizeIndicator options={resizeOptions} position="bottom" />
      <ResizeIndicator options={resizeOptions} position="left" />
      <ResizeIndicator options={resizeOptions} position="right" />
    </>
  );
}
type ResizeIndicatorProps = {
  position: ResizePosition;
  options: SharedValue<Record<ResizePosition, ResizeOptions>>;
};
function ResizeIndicator(props: ResizeIndicatorProps) {
  const theme = useTheme();
  const vertical = props.position === "bottom" || props.position === "top";
  const animatedStyle = useAnimatedStyle(() => ({
    cursor:
      props.position === "top" || props.position === "bottom"
        ? "ns-resize"
        : ("ew-resize" as any),
    display:
      props.options.value[props.position].collapse ||
      props.options.value[props.position].expand
        ? "flex"
        : "none",

    transform: [
      {
        scale: withTiming(
          props.options.value[props.position].collapse ||
            props.options.value[props.position].expand
            ? 1
            : 0
        ),
      },
    ],
  }));
  return (
    <Box
      style={{
        position: "absolute",
        right: props.position === "right" ? 0 : undefined,
        left: props.position === "left" ? 0 : undefined,
        top: props.position === "top" ? 0 : undefined,
        bottom: props.position === "bottom" ? 0 : undefined,
        height: vertical ? undefined : "100%",
        width: vertical ? "100%" : undefined,
        alignItems: "center",
        justifyContent: "center",
      }}
      space="xsmall"
    >
      <Animated.View
        style={[
          {
            height: vertical ? 8 : 40,
            width: vertical ? 40 : 8,
            borderRadius: 4,
            flexDirection: vertical ? "column" : "row",
            alignItems: "center",
            justifyContent: "center",
            opacity: 0.9,
            backgroundColor: theme.darkText,
          },
          animatedStyle,
        ]}
      />
    </Box>
  );
}
